<template>
    <DataTable
        name="group.index"
        :headers="headers"
        :rows="rows"
        :meta="meta"
        :loading="loading"
        :error="error"
        resource="employee.single.index"
        @update="refresh"
    >
        <template v-slot:first_name="{ item }">
            <div class="flex items-center">
                <Avatar :image="item.avatar" :name="item.full_name" />
                <div class="ml-3">
                    <div class="text-sm font-medium text-slate-900">
                        {{ item.full_name }}
                    </div>
                    <div class="text-sm text-slate-500">
                        {{ item.email || "No email found" }}
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:locale="{ item }">
            {{ $t(`language.${item.locale}`) }}
        </template>
        <template v-slot:status="{ item }">
            <Badge
                :variant="
                    item.status === 'active'
                        ? BadgeVariants.SUCCESS
                        : BadgeVariants.ERROR
                "
                :text="$t('employees.' + item.status).toString()"
            />
        </template>
        <template v-slot:created_at="{ item }">
            {{ item.created_at | formatDate }}
        </template>
    </DataTable>
</template>

<script>
import { IconEnums } from "@/utils/icons";
import { formatDate } from "@/utils/date";

import DataTableMixin from "@/components/tables/DataTableMixin";
import Badge, { BadgeVariants } from "@/components/shared/Badge";
import Avatar from "@/components/shared/Avatar";

export default {
    name: "GroupEmployeeTable",
    mixins: [DataTableMixin],
    components: {
        Avatar,
        Badge,
    },
    filters: {
        /**
         * @type {String}
         */
        formatDate,
    },
    data: () => ({
        BadgeVariants,
        IconEnums,
        headers: [
            {
                title: "employee",
                key: "first_name",
                sortable: false,
            },
            {
                title: "status",
                key: "status",
                sortable: false,
            },
            {
                title: "locale",
                key: "locale",
                sortable: false,
            },
            {
                title: "created",
                key: "created_at",
                sortable: false,
            },
        ],
    }),
};
</script>
